import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <header 
      className="navbar-header fixed top-0 left-0 right-0 z-50 bg-white shadow-sm"
    >
      <div className="w-full h-full px-4 md:px-6 lg:px-8 max-w-full">
        <div className="flex items-center justify-between h-full">
          
          {/* Logo Container */}
          <div className="logo-container flex-shrink-0">
            <Link to="/" data-testid="logo-link">
              <img 
                src="https://customer-assets.emergentagent.com/job_91edb9d9-5d41-4003-a549-830c6def8bd5/artifacts/cilixkw3_PerfectPeach%20logo%20rectangle%203%28600%20x%20180%20px%29.png" 
                alt="The Perfect Peach Club"
                data-testid="header-logo"
              />
            </Link>
          </div>

          {/* Mobile: Cart + Menu Icons */}
          <div className="flex md:hidden items-center gap-2">
            {/* Mobile Cart Icon */}
            <Link
              to="/cart"
              className="relative p-2"
              data-testid="mobile-cart-icon"
            >
              <ShoppingCart className="w-6 h-6 text-african-earth" />
              {cartCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-perfect-peach text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center font-semibold">
                  {cartCount}
                </span>
              )}
            </Link>
            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-african-earth p-2"
              data-testid="mobile-menu-button"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Desktop Navigation - Right aligned */}
          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/products"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-lg"
              data-testid="products-nav-link"
            >
              Products
            </Link>
            <Link
              to="/about"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-lg"
              data-testid="about-nav-link"
            >
              Our Story
            </Link>
            <Link
              to="/cart"
              className="relative"
              data-testid="cart-nav-link"
            >
              <ShoppingCart className="w-7 h-7 text-african-earth hover:text-perfect-peach transition-colors duration-300" />
              {cartCount > 0 && (
                <span
                  className="absolute -top-2 -right-2 bg-perfect-peach text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium"
                  data-testid="cart-count-badge"
                >
                  {cartCount}
                </span>
              )}
            </Link>
          </nav>
        </div>
      </div>

      {/* Mobile Menu - Full Screen Overlay */}
      {isMenuOpen && (
        <div
          className="md:hidden fixed inset-0 top-[80px] bg-white z-40"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-8 flex flex-col gap-1">
            <Link
              to="/products"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-xl py-4 border-b border-gray-100"
              onClick={() => setIsMenuOpen(false)}
              data-testid="mobile-products-link"
            >
              Products
            </Link>
            <Link
              to="/about"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-xl py-4 border-b border-gray-100"
              onClick={() => setIsMenuOpen(false)}
              data-testid="mobile-about-link"
            >
              Our Story
            </Link>
            <Link
              to="/shipping"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-xl py-4 border-b border-gray-100"
              onClick={() => setIsMenuOpen(false)}
            >
              Shipping & Delivery
            </Link>
            <Link
              to="/returns"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-xl py-4 border-b border-gray-100"
              onClick={() => setIsMenuOpen(false)}
            >
              Returns & Refunds
            </Link>
            <Link
              to="/track-order"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-xl py-4 border-b border-gray-100"
              onClick={() => setIsMenuOpen(false)}
              data-testid="mobile-track-order-link"
            >
              Track My Order
            </Link>
            <Link
              to="/cart"
              className="text-african-earth hover:text-perfect-peach transition-colors duration-300 font-medium text-xl py-4 flex items-center gap-3"
              onClick={() => setIsMenuOpen(false)}
              data-testid="mobile-cart-link"
            >
              <ShoppingCart className="w-5 h-5" />
              Cart {cartCount > 0 && <span className="text-perfect-peach">({cartCount})</span>}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navigation;
